import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Campaign } from '../marketing/campaign';
import { CampaignDialogItem, CampaignDialogItemStoreService } from './campaign-dialog-item-store.service';

@Component({
  selector: 'app-campaign-dialog-item',
  template: `
    <div class="campaign-dialog-item">
      <div class="campaign-details">
        <div class="campaign-name">{{ campaignDialogItem.name }}</div>
        <div class="campaign-description" *ngIf="campaignDialogItem.description">
          {{ campaignDialogItem.description }}
        </div>
      </div>
      <div class="campaign-status-action">
        <div class="campaign-status">
          <mat-chip-listbox *ngIf="campaignDialogItem.statusText">
            <mat-chip-option [ngClass]="campaignDialogItem.statusColor">
              {{ campaignDialogItem.statusText }}
            </mat-chip-option>
          </mat-chip-listbox>
        </div>

        <div class="campaign-action" *ngIf="campaignDialogItem.currentStatus !== 'completed'">
          <button mat-raised-button (click)="clicked()">
            {{ campaignDialogItem.buttonText }}
          </button>
        </div>
      </div>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  `,
  styleUrls: ['./campaign-dialog-item.component.scss'],
  standalone: false,
})
export class CampaignDialogItemComponent implements OnDestroy {
  @Input() set campaign(c: Campaign) {
    this.setCampaign(c);
  }

  @Input() userId: string;
  @Input() accountGroupId: string;
  @Input() marketId: string;

  loading = false;
  _campaign: Campaign;
  campaignDialogItem: CampaignDialogItem;
  subscriptions: Subscription[] = [];

  constructor(private campaignDialogItemService: CampaignDialogItemStoreService) {}

  setCampaign(c: Campaign): void {
    this._campaign = c;
    this.campaignDialogItem = this.campaignDialogItemService.convertToCampaignDialogItem(c);
  }

  clicked(): void {
    this.loading = true;
    this.subscriptions.push(
      this.campaignDialogItemService.updateStatus(this._campaign, this.userId, this.accountGroupId).subscribe(
        (result) => {
          this._campaign.nextStepScheduledDate = result.scheduledTime;
          this._campaign.recipientCampaignId = result.recipientCampaignId;
          this._campaign.recipientCampaignStatus = result.status;
          this.setCampaign(this._campaign);
        },
        (err) => {
          this.campaignDialogItemService.handleUpdateStatusError(err, this.marketId);
          this.loading = false;
        },
        () => (this.loading = false),
      ),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
